import { ViewerMaterialWrapper } from './ViewerMaterialWrapper.js';
export class MaterialCollection {
    constructor(materials) {
        this._materials = new Map();
        materials.forEach((material) => {
            this._materials.set(material.viewer_id, material);
        });
    }
    /**
     * Returns a map of all of the Viewer Materials in the material collection
     */
    get materials() {
        const viewer_materials = new Map();
        this._materials.forEach((value, key) => {
            if (value instanceof ViewerMaterialWrapper) {
                viewer_materials.set(key, value);
            }
        });
        return viewer_materials;
    }
    get is_empty() {
        return this._materials.size === 0;
    }
    clone(name_remapper = (s) => s) {
        return new MaterialCollection([...this._materials.values()].map((material) => material.clone(name_remapper)));
    }
}
//# sourceMappingURL=MaterialCollection.js.map